import {Component, Input, OnInit} from '@angular/core';
import {ConfigTurnsService} from "../../../services/turns-services/config-turns-service/config-turns.service";
import {SnackBarService} from "../../shared-components/snack-bar/snack-bar.service";
import {FormControl, FormGroup} from "@angular/forms";
import {tap} from "rxjs/internal/operators/tap";
import {catchError} from "rxjs/internal/operators/catchError";
import {EMPTY, Subscription} from "rxjs";

@Component({
  selector: 'app-turns-config-ui-card',
  templateUrl: './turns-config-ui-card.component.html',
  styleUrls: ['./turns-config-ui-card.component.scss']
})
export class TurnsConfigUiCardComponent implements OnInit {

  @Input() config;
  broadcastingModes;
  languageIconModes;
  editingLocked: boolean;
  updateTurnsConfigHelpSubscription: Subscription;

  basicDataForm = new FormGroup({
    broadcastingMode: new FormControl(null),
    languageIconMode: new FormControl(null),
    backgroundColour: new FormControl(null),
    textPrimaryColour: new FormControl(null),
    textSecondaryColour: new FormControl(null),
    takeTurnsFromBroadcast: new FormControl(false),
  });

  constructor(private configTurnsService: ConfigTurnsService,
              private snackbarService: SnackBarService) {
    this.broadcastingModes = Object.values(BroadcastingModesEnum);
    this.languageIconModes = Object.values(LanguageIconsEnum);

  }

  ngOnInit() {}

  ngOnChanges() {
    if (this.config) {
      this.resetForm();
      this.lockEdition();
    }
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      this.submitForm();
    }
  }

  // private validateForm() {
  //   if (this.basicDataForm.get('checkPrincipalDesk').value && !this.basicDataForm.get('principalDesk').value) {
  //     return 'turns-page.snackbar messages.principal desk error';
  //   } else {
  //     return true;
  //   }
  // }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1 === op2;
    }
  }

  public submitForm() {
    this.updateTurnsConfigHelpSubscription = this.configTurnsService.updateTurnsConfigUI(
      this.basicDataForm.get('broadcastingMode').value,
      this.basicDataForm.get('languageIconMode').value,
      this.basicDataForm.get('backgroundColour').value,
      this.basicDataForm.get('textPrimaryColour').value,
      this.basicDataForm.get('textSecondaryColour').value,
      this.basicDataForm.get('takeTurnsFromBroadcast').value
    ).pipe(
      tap(o => this.configTurnsService.refreshTurnsConfig()),
      catchError(error => {
        this.snackbarService.open(error['data']['error'], 'error');
        this.configTurnsService.refreshTurnsConfig();
        return EMPTY; })
    ).subscribe();
  }

  public resetForm() {
    console.dir(this.config);
    this.basicDataForm.patchValue({
      broadcastingMode: this.config.broadcastingMode ? this.config.broadcastingMode : BroadcastingModesEnum.DEACTIVATED.valueOf(),
      languageIconMode: this.config.languageIconMode ? this.config.languageIconMode : LanguageIconsEnum.ICON.valueOf(),
      backgroundColour: this.config.backgroundColor ? this.config.backgroundColor : "#FFFFFF",
      textPrimaryColour: this.config.textPrimaryColor ? this.config.textPrimaryColor : "#000000",
      textSecondaryColour: this.config.textSecondaryColor ? this.config.textSecondaryColor : "#000000",
      takeTurnsFromBroadcast: this.config.takeTurnsFromBroadcast
    });
  }

  private unlockEdition() {
    this.basicDataForm.get('broadcastingMode').enable();
    this.basicDataForm.get('languageIconMode').enable();
    this.basicDataForm.get('backgroundColour').enable();
    this.basicDataForm.get('textPrimaryColour').enable();
    this.basicDataForm.get('textSecondaryColour').enable();
    this.basicDataForm.get('takeTurnsFromBroadcast').enable();
    this.editingLocked = false;
  }

  private lockEdition() {
    this.basicDataForm.get('broadcastingMode').disable();
    this.basicDataForm.get('languageIconMode').disable();
    this.basicDataForm.get('backgroundColour').disable();
    this.basicDataForm.get('textPrimaryColour').disable();
    this.basicDataForm.get('textSecondaryColour').disable();
    this.basicDataForm.get('takeTurnsFromBroadcast').disable();
    this.editingLocked = true;
  }

}

export enum BroadcastingModesEnum {
  'DEACTIVATED' = 'DEACTIVATED',
  'FULLSCREEN' = 'FULLSCREEN',
  'FULLSCREEN_SPLIT' = 'FULLSCREEN_SPLIT',
  'EMBEDDED' = 'EMBEDDED'
}

export enum LanguageIconsEnum {
  'ICON' = 'ICON',
  'TEXT' = 'TEXT'
}
